import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/router';
import { ProductSlug } from '../../../../domain/products';
import SignupLayout from '../components/scenes/SigninScene/SignupLayout';
const SignUp = () => {
  const $ = _c(6);
  const router = useRouter();
  const t0 = router.query.error as string;
  const t1 = router.query.redirect as string;
  const t2 = router.query.promotion as string;
  const t3 = router.query.ref as string;
  const t4 = router.query.product_source as ProductSlug;
  let t5;
  if ($[0] !== t0 || $[1] !== t1 || $[2] !== t2 || $[3] !== t3 || $[4] !== t4) {
    t5 = <SignupLayout default_error={t0} redirect={t1} promotion_slug={t2} referrer_slug={t3} product_source={t4} />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
SignUp.configs = {
  title: 'Sign Up with Hookdeck',
  desc: 'Get started with Hookdeck by creating your account'
};
export default SignUp;